import { render, staticRenderFns } from "./wtMassProduce.upload.component.vue?vue&type=template&id=56833456&scoped=true&"
import script from "./wtMassProduce.upload.component.vue?vue&type=script&lang=js&"
export * from "./wtMassProduce.upload.component.vue?vue&type=script&lang=js&"
import style0 from "./wtMassProduce.upload.component.vue?vue&type=style&index=0&id=56833456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56833456",
  null
  
)

export default component.exports